import { Typography, Button } from '@mui/material';
import { Link } from '@remix-run/react';

const BackHomeButton = () => {
  return (
    <Button variant="text" component={Link} to="/" sx={{ justifyContent: 'flex-start' }}>
      <Typography variant="body1">Take me back home →</Typography>
    </Button>
  );
};

export default BackHomeButton;
